import { lazyLoad } from 'utils/loadable';

export const NewDashboard = lazyLoad(
  () => import('./index'),
  module => module.NewDashboard,
);
